// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { atualizarRepresentante } from "../../../services/atualizarRepresentanteService";

export const useExcluirRepresentante = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const excluirRepre = async (representanteId: number | undefined | null) => {
    setIsLoading(true);

    if (representanteId) {
      const representanteDataNovo = {
        checked: 0,
        active: 0,
        representanteId: representanteId,
      };

      try {
        const atualizarDados = await atualizarRepresentante(
          representanteDataNovo
        );

        if (atualizarDados) {
          setSuccess("Representante excluido com Sucesso!");
        } else {
          setError(
            "Não foi possível excluir este representante. Tente Novamente!"
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return { excluirRepre, isLoading, resetError, resetSuccess, error, success };
};
